import { render, staticRenderFns } from "./cpt-dataV-activeRing-option.vue?vue&type=template&id=4f1b443f&scoped=true"
import script from "./cpt-dataV-activeRing-option.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-activeRing-option.vue?vue&type=script&lang=js"
import style0 from "./cpt-dataV-activeRing-option.vue?vue&type=style&index=0&id=4f1b443f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1b443f",
  null
  
)

export default component.exports